/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Sortby_Lastmodifieddate3Inputs */

const id_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Dimodifikasi`)
};

const ms_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Diubah Suai`)
};

const da_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringsdato`)
};

const de_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsdatum`)
};

const en_us2_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified Date`)
};

const es_es2_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de modificación`)
};

const es_mx2_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de modificación`)
};

const fil_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Pagbabago`)
};

const fr_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de modification`)
};

const it_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data modifica`)
};

const hu_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módosítás dátuma`)
};

const nl_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingsdatum`)
};

const no_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringsdato`)
};

const pl_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data modyfikacji`)
};

const pt_br2_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de modificação`)
};

const pt_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de modificação`)
};

const ro_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data modificării`)
};

const fi_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkauspäivä`)
};

const sv_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringsdatum`)
};

const vi_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày sửa đổi`)
};

const tr_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştirilme Tarihi`)
};

const cs_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum změny`)
};

const bg_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на промяна`)
};

const ru_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата изменения`)
};

const uk_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата зміни`)
};

const ar_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ التعديل`)
};

const hi_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संशोधित तारीख़`)
};

const th_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่แก้ไข`)
};

const ja_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日`)
};

const zh_cn2_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改日期`)
};

const zh_hant1_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改日期`)
};

const ko_tags_sortby_lastmodifieddate3 = /** @type {(inputs: Tags_Sortby_Lastmodifieddate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정일`)
};

/**
* | output |
* | --- |
* | "Modified Date" |
*
* @param {Tags_Sortby_Lastmodifieddate3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const tags_sortby_lastmodifieddate3 = /** @type {((inputs?: Tags_Sortby_Lastmodifieddate3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Sortby_Lastmodifieddate3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "ms") return ms_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "da") return da_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "de") return de_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "en-US") return en_us2_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "es-ES") return es_es2_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "es-MX") return es_mx2_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "fil") return fil_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "fr") return fr_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "it") return it_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "hu") return hu_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "nl") return nl_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "no") return no_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "pl") return pl_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "pt-BR") return pt_br2_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "pt") return pt_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "ro") return ro_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "fi") return fi_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "sv") return sv_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "vi") return vi_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "tr") return tr_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "cs") return cs_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "bg") return bg_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "ru") return ru_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "uk") return uk_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "ar") return ar_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "hi") return hi_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "th") return th_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "ja") return ja_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_sortby_lastmodifieddate3(inputs)
	if (locale === "zh-Hant") return zh_hant1_tags_sortby_lastmodifieddate3(inputs)
	return ko_tags_sortby_lastmodifieddate3(inputs)
});
export { tags_sortby_lastmodifieddate3 as "tags.sortBy.lastModifiedDate" }